import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { ClientEnvironment, ConfigObjectModel, ENVIRONMENT, anyAsset } from '@thehubz/client/core';
import { Collection, CollectionsApiService } from '@thehubz/client/data-access-api';
import { CustomClients } from '@thehubz/shared/branding';
import { AnyType } from '@thehubz/shared/model';
import { AssetCommonService } from '../../../../../services/asset-common.service';
@Component({
  selector: 'thehubz-collection-action-menu',
  templateUrl: './collection-action-menu.component.html',
  styleUrls: ['./collection-action-menu.component.scss'],
})
export class CollectionActionMenuComponent implements OnInit {
  @Input() configObject!: ConfigObjectModel;
  @Input() collectionIndex!: number;
  @Input() assetDetails = '';
  @Input() collection!: AnyType;
  @Output() deleteCollection = new EventEmitter<any>();
  @Output() downloadCollection = new EventEmitter<any>();
  @Output() shareCollection = new EventEmitter<any>();
  @Output() publishCollection = new EventEmitter<any>();
  @Output() unpublishCollection = new EventEmitter<any>();
  @Output() editCollection = new EventEmitter<any>();
  AnyAsset = anyAsset;
  spinnerDiameter = 50;
  collectionOwner = false;
  collectionPublished = false;
  /**
   * True when data is loading from server
   */
  httpCallInProgress = false;
  brandingKey: CustomClients;
  CustomClients = CustomClients;

  constructor(
    @Inject(ENVIRONMENT) readonly env: ClientEnvironment,
    private assetCommonService: AssetCommonService,
    private collectionAPIService: CollectionsApiService,
  ) {
    this.brandingKey = this.env.brandingKey;
  }
  @ViewChild('taskMenuTrigger') trigger!: MatMenuTrigger;

  ngOnInit(): void {
    if (this.collection.published && this.collection.published.length > 0) {
      this.collectionPublished = true;
    }
    this.collectionOwner = this.assetCommonService.checkCollectionOwner(this.collection);
  }

  openMenu() {
    this.collectionAPIService.collectionsControllerFindOne(this.collection._id).subscribe(async (resp: Collection) => {
      if (resp.published && resp.published.length > 0) {
        this.collectionPublished = true;
      } else {
        this.collectionPublished = false;
      }
      this.trigger.openMenu();
    });
  }

  menuOpened(id: string) {
    const row = document.getElementById(`row-${id}`);
    if (row) {
      row.classList.add('highlight');
    }
  }

  menuClosed(id: string) {
    const row = document.getElementById(`row-${id}`);
    if (row) {
      row.classList.remove('highlight');
    }
  }
}
